import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable';

/** V2 본문·레거시 문서 본문 모두 태그·클래스로 스타일링 */
export const CostQuotationRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 720 },
  '& table + table': { marginTop: -1 },
  '& .cq-card + .cq-card, & #grid > div + div': { marginTop: 16 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& .text-left': { textAlign: 'left' },
  '& td.label, & .bg-title, & .bg-gray, & .bg-gray2': {
    textAlign: 'center',
    backgroundColor: theme.palette.grey[50],
  },
  '& .cq-highlight td, & tr > .bg-gray': {
    backgroundColor: theme.palette.grey[50],
  },
  '& strong': { fontWeight: 700 },
  '& .cq-emphasis, & font': { color: theme.palette.error.main },
  '& .cq-image, & th[rowspan]': {
    backgroundColor: theme.palette.common.white,
  },
  '& .cq-image img, & th[rowspan] > img': {
    display: 'block',
    maxWidth: 300,
    width: '100%',
    height: 'auto',
    margin: '0 auto',
  },
  '& .cq-card-title-row': {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minHeight: 32,
  },
  '& .cq-card-title-row > span:first-of-type': { flex: 1 },
}));
